import React, { useMemo } from 'react';
import { Row } from 'antd';
import BudgetHeaderDisplayCard from '../budget_header_display_card/BudgetHeaderDisplayCard';
import { isNotUndefined, nullSafeGet } from '../../utils/DataAccessUtils';
interface BudgetHeaderDisplayRowProps {
	budget: any;
	currency: any;
}

const BudgetHeaderDisplayRow: React.FC<BudgetHeaderDisplayRowProps> = ({ budget, currency }) => {
	const budgetLimit = useMemo(() => nullSafeGet('totalBudgetForCurrentCycle', budget), [budget]);
	const remainingBudget = useMemo(
		() => nullSafeGet('remainingBudgetForCurrentCycle', budget),
		[budget]
	);
	const actualSpending = useMemo(() => nullSafeGet('budgetSpent', budget), [budget]);
	const accruals = useMemo(() => nullSafeGet('budgetAccrued', budget), [budget]);

	const isRemainingOverBudget = useMemo(() => remainingBudget < 0, [remainingBudget]);

	const remainigCardProps = useMemo(
		() => ({
			title: isRemainingOverBudget ? 'Over Budget' : 'Remaining',
			description: isRemainingOverBudget
				? 'The amount over the budget total.'
				: 'The total budget minus the accrued and spent amounts for the selected period.',
			color: isRemainingOverBudget ? 'red' : 'green',
		}),
		[isRemainingOverBudget]
	);

	return (
		<Row gutter={4}>
			{isNotUndefined(budgetLimit) ? (
				<BudgetHeaderDisplayCard
					title={'Budget Total'}
					message={'The budget amount for the current period.'}
					amount={budgetLimit}
					span={6}
					currency={currency}
				/>
			) : null}
			<BudgetHeaderDisplayCard
				title={'Spent'}
				message={
					'The accumulated total of approved, processing and paid invoices for the selected period.'
				}
				amount={actualSpending}
				span={6}
				currency={currency}
			/>
			<BudgetHeaderDisplayCard
				title={'Accrued'}
				message={'The total from the selected accrual types tracked for the selected period.'}
				amount={accruals}
				span={6}
				currency={currency}
			/>
			{isNotUndefined(budgetLimit) ? (
				<BudgetHeaderDisplayCard
					title={remainigCardProps.title}
					message={remainigCardProps.description}
					amount={Math.abs(remainingBudget)}
					span={6}
					color={remainigCardProps.color}
					currency={currency}
				/>
			) : null}
		</Row>
	);
};

export default BudgetHeaderDisplayRow;
